import React from 'react'

export default ({ icon, className = '', ...props }) => {
  return (
    <svg className={`${className} icon`} {...props}>
      <use xlinkHref={icon} />
    </svg>
  )
}
